"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const bus_sparql_serialize_1 = require("@comunica/bus-sparql-serialize");
const rdf_terms_1 = require("rdf-terms");
const stream_1 = require("stream");
/**
 * A comunica Table Sparql Serialize Actor.
 */
class ActorSparqlSerializeTable extends bus_sparql_serialize_1.ActorSparqlSerializeFixedMediaTypes {
    constructor(args) {
        super(args);
        this.padding = ActorSparqlSerializeTable.repeat(' ', this.columnWidth);
    }
    static repeat(str, count) {
        return new Array(count + 1).join(str);
    }
    async testHandleChecked(action, context) {
        if (['bindings', 'quads'].indexOf(action.type) < 0) {
            throw new Error('This actor can only handle bindings or quad streams.');
        }
        return true;
    }
    pad(str) {
        if (str.length <= this.columnWidth) {
            return str + this.padding.slice(str.length);
        }
        else {
            return str.slice(0, this.columnWidth - 1) + '…';
        }
    }
    pushHeader(data, labels) {
        const header = labels.map(this.pad, this).join(' ');
        data.push(header + '\n' + ActorSparqlSerializeTable.repeat('-', header.length) + '\n');
    }
    async runHandle(action, mediaType, context) {
        const data = new stream_1.Readable();
        data._read = () => {
            return;
        };
        let resultStream;
        if (action.type === 'bindings') {
            resultStream = action.bindingsStream;
            this.pushHeader(data, action.variables);
            resultStream.on('error', (e) => data.emit('error', e));
            resultStream.on('data', (bindings) => data.push(bindings.map((value, key) => this.pad(value ? value.value : '')).join(' ') + '\n'));
        }
        else {
            resultStream = action.quadStream;
            this.pushHeader(data, rdf_terms_1.QUAD_TERM_NAMES);
            resultStream.on('error', (e) => data.emit('error', e));
            resultStream.on('data', (quad) => data.push(rdf_terms_1.getTerms(quad).map((term) => this.pad(term.value)).join(' ') + '\n'));
        }
        resultStream.on('end', () => data.push(null));
        return { data };
    }
}
exports.ActorSparqlSerializeTable = ActorSparqlSerializeTable;
//# sourceMappingURL=ActorSparqlSerializeTable.js.map